export default __webpack_public_path__ + "images/banner-girl.32c5e579bba2d7a003a0a0b2cc711f20.png";